__turbopack_context__.v({
  "container": "XTS2Ba_container",
  "content": "XTS2Ba_content",
  "isOverflowHidden": "XTS2Ba_isOverflowHidden",
  "isVisible": "XTS2Ba_isVisible",
});
